import React from "react";
import { Button, Modal } from "antd";

type PatientConfirmationModalProps = {
  handleCancel: any;
  handleConfirm: any;
  open: boolean;
};

const PatientConfirmationModal: React.FC<PatientConfirmationModalProps> = ({
  handleCancel,
  handleConfirm,
  open,
}) => {
  return (
    <>
      <Modal
        open={open}
        title="Do you want to proceed to add Patient Scheme?"
        onCancel={handleCancel}
        footer={(_, { CancelBtn }) => (
          <>
            <Button onClick={handleConfirm}>Confirm</Button>
            <CancelBtn />
          </>
        )}
      ></Modal>
    </>
  );
};

export default PatientConfirmationModal;
